const MODULE_PATTERNS = {
	"/historiales": {
		visualization: "Cliente",
		module_general: "Historiales",
		routes: {
			"/": "Historiales - Inicio",
			"/compra": "Historiales - Compra",
			"/salida": "Historiales - Salida",
			"/en_uso": "Historiales - En Uso",
			"/usos": "Historiales - Usos",
			"/otros_movimientos": "Historiales - Otros Movimientos",
		},
	},
	"/ordenes_compra": {
		visualization: "Cliente",
		module_general: "Órdenes de Compra",
		routes: {
			"/": "Órdenes de Compra - Listado",
		},
	},
	"/facturas": {
		visualization: "Cliente",
		module_general: "Facturas",
		routes: {
			"/": "Facturas - Listado",
		},
	},
	"/guias_despacho": {
		visualization: "Cliente",
		module_general: "Guías de Despacho",
		routes: {
			"/": "Guías de Despacho - Listado",
		},
	},
	"/sin_documento": {
		visualization: "Cliente",
		module_general: "Sin Documento",
		routes: {
			"/": "Sin Documento - Listado",
		},
	},
	"/nota_credito": {
		visualization: "Cliente",
		module_general: "Nota de Crédito",
		routes: {
			"/": "Nota de Crédito - Listado",
		},
	},
	"/envases_vacios": {
		visualization: "Cliente",
		module_general: "Envases Vacíos",
		routes: {
			"/": "Envases Vacíos - Listado",
		},
	},
	"/carga_inventario_inicial": {
		visualization: "Cliente",
		module_general: "Carga Inventario Inicial",
		routes: {
			"/": "Carga Inventario Inicial - Carga",
		},
	},
	"/notificaciones": {
		visualization: "Cliente",
		module_general: "Notificaciones",
		routes: {
			"/": "Notificaciones - Listado",
		},
	},
	"/perfil": {
		visualization: "Cliente",
		module_general: "Perfil",
		routes: {
			"/": "Perfil - General",
		},
	},
	"/planificacion": {
		visualization: "Cliente",
		module_general: "Planificación",
		routes: {
			"/": "Planificación - Inicio",
			"/programa_fitosanitario": "Planificación - Programa Fitosanitario",
		},
	},
	"/inventario": {
		visualization: "Cliente",
		module_general: "Inventario",
		routes: {
			"/": "Inventario - Listado",
		},
	},
	"/productos": {
		visualization: "Cliente",
		module_general: "Productos",
		routes: {
			"/": "Productos - Listado",
		},
	},
	"/soporte": {
		visualization: "Cliente",
		module_general: "Soporte",
		routes: {
			"/actualizaciones": "Soporte - Actualizaciones",
		},
	},
	"/ordenes_aplicacion": {
		visualization: "Cliente",
		module_general: "Órdenes de Aplicación",
		routes: {
			"/": "Órdenes de Aplicación - Listado",
		},
	},
	"/orden_aplicacion": {
		visualization: "Cliente",
		module_general: "Orden de Aplicación",
		routes: {
			"/": "Orden de Aplicación - Crear/Editar",
		},
	},
	"/mantenedores": {
		visualization: "Administrador",
		module_general: "Mantenedores",
		routes: {
			"/": "Mantenedores - Inicio",
			"/encuestas": "Mantenedores - Encuestas",
			"/clientes": "Mantenedores - Clientes",
			"/especies": "Mantenedores - Especies",
			"/codigos": "Mantenedores - Códigos",
			"/productos": "Mantenedores - Productos",
			"/usuarios": "Mantenedores - Usuarios",
			"/aptitudes": "Mantenedores - Aptitudes",
			"/distribuidores": "Mantenedores - Distribuidores",
			"/versiones": "Mantenedores - Versiones",
			"/balanzas": "Mantenedores - Balanzas",
			"/ingredientes_activos": "Mantenedores - Ingredientes Activos",
			"/incidencias": "Mantenedores - Incidencias",
			"/paginas_web": "Mantenedores - Páginas Web",
			"/contenidos_web": "Mantenedores - Contenidos Web",
			"/centro_ayuda": "Mantenedores - Centro de Ayuda",
			"/aplicaciones": "Mantenedores - Aplicaciones",
		},
	},
	"/configuracion": {
		visualization: "Cliente",
		module_general: "Configuración",
		routes: {
			"/": "Configuración - Inicio",
			"/integraciones": "Configuración - Integraciones",
			"/cliente": "Configuración - Cliente",
			"/razones_sociales": "Configuración - Razones Sociales",
			"/campos": "Configuración - Campos",
			"/maquinarias": "Configuración - Maquinarias",
			"/clasificaciones_oc": "Configuración - Clasificaciones OC",
			"/usuarios": "Configuración - Usuarios",
			"/operadores": "Configuración - Operadores",
			"/tipo_orden_aplicacion": "Configuración - Tipo Orden Aplicación",
			"/estado_fenologico_oa": "Configuración - Estado Fenológico OA",
			"/objetivos_oa": "Configuración - Objetivos OA",
			"/riegos": "Configuración - Riegos",
			"/categorias": "Configuración - Categorías",
			"/paso-1": "Configuración - Especies",
			"/paso-2": "Configuración - Variedades",
			"/paso-3": "Configuración - Cuarteles",
			"/centro_costo": "Configuración - Centro de Costo",
			"/transportistas": "Configuración - Transportistas",
			"/grupos_campos": "Configuración - Grupos de Campos",
			"/especies_variedades": "Configuración - Especies y Variedades",
			"/listas_difusion": "Configuración - Listas de Difusión",
		},
	},
	"/reportes": {
		visualization: "Cliente",
		module_general: "Reportes",
		routes: {
			"/mensual": "Reportes - Mensual",
		},
	},
	"/": {
		visualization: "Cliente",
		module_general: "Dashboard",
		routes: {
			"/": "Dashboard - Inicio",
		},
	},
};

export const getTrackingConfig = (pathname) => {
	for (const [baseRoute, config] of Object.entries(MODULE_PATTERNS)) {
		if (pathname === baseRoute) {
			return {
				visualization: config.visualization,
				module_general: config.module_general,
				module_specific: config.routes["/"],
			};
		}

		if (pathname.startsWith(baseRoute + "/")) {
			const subRoute = pathname.substring(baseRoute.length);

			if (config.routes[subRoute]) {
				return {
					visualization: config.visualization,
					module_general: config.module_general,
					module_specific: config.routes[subRoute],
				};
			}

			const parts = subRoute.split("/").filter((p) => p);
			const lastPart = parts[parts.length - 1] || "";

			if (!isNaN(lastPart) || lastPart.length > 20) {
				const action = parts[parts.length - 2] || "";
				if (["crear", "create", "nuevo", "new"].includes(action)) {
					return {
						visualization: config.visualization,
						module_general: config.module_general,
						module_specific: `${config.module_general.charAt(0)}. Crear`,
					};
				} else if (["editar", "edit"].includes(action)) {
					return {
						visualization: config.visualization,
						module_general: config.module_general,
						module_specific: `${config.module_general.charAt(0)}. Editar`,
					};
				}
				return {
					visualization: config.visualization,
					module_general: config.module_general,
					module_specific: `${config.module_general.charAt(0)}. Ver Detalle`,
				};
			}

			const formattedName = lastPart
				.replace(/_/g, " ")
				.replace(/-/g, " ")
				.split(" ")
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(" ");

			return {
				visualization: config.visualization,
				module_general: config.module_general,
				module_specific: `${config.module_general.charAt(0)}. ${formattedName || "General"}`,
			};
		}
	}

	return null;
};

export const generateSessionId = () => {
	const timestamp = Date.now();
	const random = Math.random().toString(36).substring(2, 15);
	return `session_${timestamp}_${random}`;
};

export const getSessionId = () => {
	let sessionId = sessionStorage.getItem("tracking_session_id");
	if (!sessionId) {
		sessionId = generateSessionId();
		sessionStorage.setItem("tracking_session_id", sessionId);
	}
	return sessionId;
};
